export const DB_LAST_USED = 'vgsLastUsed';
export const DB_CHECKLIST = 'vgsChecklists';
export const DB_SUBJECT_LEVEL = 'vgsSubjectLevel';
